import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { useWindowSize } from "go-core/components/useWindowSize";
import { CompanyApi } from "../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../services/Api/api";
import CompanyForm from "./components/CompanyForm";

const OrganizationSettingsCompanyPage = () => {
	const [company, setCompany] = useState<CompanyApi | undefined>(undefined);
	const { addFlash } = useFlash();
	const { t } = useTranslation();
	const isMobile = useWindowSize().isMobile;
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(t("modules.company.header.title"));
		onFetchCompany();
	}, []);

	const onFetchCompany = async () => {
		try {
			const params = { include: "bank_accounts" };
			const res = await api.organization().getCompany(params);
			setCompany(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!company) return <LoadingContainer />;

	return (
		<div className="content">
			<div className="content-preview">
				{!isMobile && <Header title={t("modules.company.header.title")} />}
				<CompanyForm company={company} />
			</div>
		</div>
	);
};

export default OrganizationSettingsCompanyPage;
